import React from 'react';
import { UpsellProvider } from '@/contexts/UpsellContext';
import { useUser } from '@/contexts/UserContext';

interface UpsellProviderWrapperProps {
  children: React.ReactNode;
}

export const UpsellProviderWrapper: React.FC<UpsellProviderWrapperProps> = ({ children }) => {
  const { user } = useUser();
  
  // Determine user role based on user data
  const getUserRole = (): 'vendor' | 'user' | 'admin' => {
    if (!user) return 'user';
    
    // Return the user's actual role from the User interface
    return user.role;
  };

  const userRole = getUserRole();

  return (
    <UpsellProvider userRole={userRole}>
      {children}
    </UpsellProvider>
  );
};